"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _I18n = _interopRequireDefault(require("I18n"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _theme = require("HubStyleTokens/theme");

var _TablePropTypes = require("./TablePropTypes");

var getArrowColor = function getArrowColor(selected, hoveredWithHint) {
  if (selected) return _theme.TABLE_SORT_ARROW_SELECTED_COLOR;
  if (hoveredWithHint) return _theme.TABLE_SORTABLE_HOVER_ICON_COLOR;
  return null;
};

var getLabelText = function getLabelText(sort) {
  if (sort === 'ascending') {
    return _I18n.default.text('ui.UISortTH.ascendingSort');
  }

  if (sort === 'descending') {
    return _I18n.default.text('ui.UISortTH.descendingSort');
  }

  return _I18n.default.text('ui.UISortTH.pressToSort');
};

var Arrow = (0, _styledComponents.default)('polygon').withConfig({
  displayName: "TableSortArrows__Arrow",
  componentId: "sc-1ecxh8g-0"
})(["fill:", ";"], function (_ref) {
  var hovered = _ref.hovered,
      preferred = _ref.preferred,
      selected = _ref.selected;
  return getArrowColor(selected, preferred && hovered);
});

var UnstyledArrows = function UnstyledArrows(props) {
  var hovered = props.hovered,
      preferredSort = props.preferredSort,
      sort = props.sort,
      rest = (0, _objectWithoutProperties2.default)(props, ["hovered", "preferredSort", "sort"]);
  return _react.default.createElement("span", Object.assign({
    "aria-label": getLabelText(sort),
    "aria-live": "polite"
  }, rest), _react.default.createElement("svg", {
    role: "presentation",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7.5 14"
  }, _react.default.createElement(Arrow, {
    hovered: hovered,
    points: "7.5 5 0 5 3.75 0 7.5 5",
    preferred: preferredSort === 'ascending' || sort === 'descending',
    selected: sort === 'ascending'
  }), _react.default.createElement(Arrow, {
    hovered: hovered,
    points: "0 9 7.5 9 3.75 14 0 9",
    preferred: preferredSort === 'descending' || sort === 'ascending',
    selected: sort === 'descending'
  })));
};

var TableSortArrows = (0, _styledComponents.default)(UnstyledArrows).withConfig({
  displayName: "TableSortArrows",
  componentId: "sc-1ecxh8g-1"
})(["display:inline-block;fill:", ";flex-shrink:0;margin-left:6px;margin-right:0;width:7.5px;"], _theme.TABLE_SORT_ARROW_COLOR);
TableSortArrows.propTypes = {
  hovered: _propTypes.default.bool.isRequired,
  preferredSort: _TablePropTypes.preferredSortPropType.isRequired,
  sort: _TablePropTypes.sortPropType.isRequired
};
TableSortArrows.displayName = 'TableSortArrows';
var _default = TableSortArrows;
exports.default = _default;
module.exports = exports.default;